import cx from 'classnames'
import { absurd } from 'types'
import Styles from './LineDividerDropdownItem.module.scss'
import { LineStyle } from './types'

type LineDividerDropdownItemProps = (props: {
  className?: string
  selected?: boolean
  style: LineStyle
}) => JSX.Element | null

export const LineDividerDropdownItem: LineDividerDropdownItemProps = ({ className, selected, style }) => {
  switch (style) {
    case 'three_dots':
      return (
        <div className={cx(Styles.lineDividerStyle, className, { [Styles.selected]: selected })}>
          <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="1" cy="1" r="1" fill="currentColor" />
            <circle cx="8" cy="1" r="1" fill="currentColor" />
            <circle cx="15" cy="1" r="1" fill="currentColor" />
          </svg>
        </div>
      )

    case 'solid_thin':
      return (
        <div
          className={cx(Styles.lineDividerStyle, Styles.solidThin, className, { [Styles.selected]: selected })}
        ></div>
      )

    case 'solid_thick':
      return (
        <div
          className={cx(Styles.lineDividerStyle, Styles.solidThick, className, { [Styles.selected]: selected })}
        ></div>
      )

    case 'dashed':
      return (
        <div className={cx(Styles.lineDividerStyle, className, { [Styles.selected]: selected })}>
          <svg width="82" height="14" viewBox="0 0 82 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="6" width="11" height="2" rx="1" fill="currentColor" />
            <rect x="68.001" y="6" width="11" height="2" rx="1" fill="currentColor" />
            <rect x="46.334" y="6" width="11" height="2" rx="1" fill="currentColor" />
            <rect x="24.667" y="6" width="11" height="2" rx="1" fill="currentColor" />
          </svg>
        </div>
      )

    case 'dotted':
      return (
        <div className={cx(Styles.lineDividerStyle, className, { [Styles.selected]: selected })}>
          <svg width="55" height="3" viewBox="0 0 55 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke="#8F98A9" strokeWidth="2" strokeLinecap="round" strokeDasharray="0.1 10" d="M1.3 1.96h51.9" />
          </svg>
        </div>
      )

    case 'dash_dot_dash':
      return (
        <div className={cx(Styles.lineDividerStyle, className, { [Styles.selected]: selected })}>
          <svg width="80" height="4" viewBox="0 0 80 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="2" r="1.5" fill="currentColor" />
            <path
              d="M48 2C48 1.45112 48.451 1.0094 48.9998 1.02083L79.6667 1.65972C79.8519 1.66358 80 1.81479 80 2C80 2.18521 79.8519 2.33642 79.6667 2.34028L48.9998 2.97917C48.451 2.9906 48 2.54888 48 2Z"
              fill="currentColor"
            />
            <path
              d="M0 2C0 1.81479 0.148094 1.66358 0.333261 1.65972L31.0002 1.02083C31.549 1.0094 32 1.45112 32 2C32 2.54888 31.549 2.9906 31.0002 2.97917L0.333261 2.34028C0.148094 2.33642 0 2.18521 0 2Z"
              fill="currentColor"
            />
          </svg>
        </div>
      )

    default:
      absurd(style)
      return null
  }
}
